import { render, staticRenderFns } from "./VacationResponder.vue?vue&type=template&id=88bae3d8"
import script from "./VacationResponder.vue?vue&type=script&lang=js"
export * from "./VacationResponder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports